<ion-header>
    <ion-toolbar #headerToolbar style="--background:var(--myDisabledEnabledColor)">
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton" [disabled]=vb.disabled></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title" #title (click)="onTitleClick()">Navigation</ion-title>
        <!-- <ion-buttons slot="end">
            <ion-button [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list-header color="secondary">
        Congratulations - (Step 5 of 5)
    </ion-list-header>

    <ion-list lines="none">
        <ion-item>
            <label class="ion-text-wrap ion-padding-top">
                <span class="line1">You have successfully navigated this route.
                You are now ready to define the next route.<br /><br />
                When you are ready click the 'Go to Routes' button below.</span>
            </label>
        </ion-item>
    </ion-list>
</ion-content>

<ion-footer>
    <ion-toolbar>
        <ion-button data-test="goToRoutes" color="primary" [disabled]=vb.disabled expand="full"  (click)="onRoutesClick()">
            Go to Routes
        </ion-button>
    </ion-toolbar>
</ion-footer>
